import { useState } from "react";

import MenuIcon from "../../images/icon_menu.svg";
import Sidebar from "../Sidebar/Sidebar";
import { UserContainer } from "../User/UserStyles";
import { Navbar, SidebarChildContainer } from "./InitialLayoutStyles";

function Menubar(props: any) {
  const { header, imageSrc, children } = props;
  const [visible, setVisible] = useState(false);
  return (
    <div>
      <Navbar>
        <UserContainer>
          <img alt="logo" src={imageSrc}></img>
          {header}
        </UserContainer>
        <button className="navbar-button" onClick={() => setVisible(true)}>
          <img alt="menu-button" src={MenuIcon} />
        </button>
      </Navbar>
      {visible ? (
        <Sidebar
          left={true}
          onOutsideClick={() => setVisible(false)}
          visible={visible}
        >
          <SidebarChildContainer>{children}</SidebarChildContainer>
        </Sidebar>
      ) : null}
    </div>
  );
}

export default Menubar;
